import AgenticCommerce from 'models/location/agentic_commerce';
import CloseReport from 'actions/reporting/close_report';
import OpenAgenticCommerce from 'actions/reporting/open_agentic_commerce';
import { registerUrlConverter } from './location_url';

registerUrlConverter(AgenticCommerce, {
  getPath: () => '/agentic-commerce',
  getQueryParams: location => (location.timezone ? { timezone: location.timezone } : {}),
});

export default function (router, { runnerContext }) {
  return {
    on: () => {
      const { timezone } = router.parseQueryParameters().toJS();
      runnerContext.executeAction(OpenAgenticCommerce, { timezone });
    },
    after() {
      runnerContext.executeAction(CloseReport);
    },
  };
}
